import { FilterParam } from '../types/filters.js';

var getAppConsistentParams = function (searchString) {
    var searchParams = new URLSearchParams(searchString);
    var newSearchParams = new URLSearchParams();
    Object.values(FilterParam).forEach(function (param) {
        if (searchParams.get(param)) {
            newSearchParams.append(param, searchParams.get(param));
        }
    });
    return newSearchParams;
};

export { getAppConsistentParams };
//# sourceMappingURL=appUtils.js.map
